import { BDropdown } from 'bootstrap-vue/src/components/dropdown/dropdown'
import { BDropdownItem } from 'bootstrap-vue/src/components/dropdown/dropdown-item'

export const Dropdown = BDropdown
export const DropdownItem = BDropdownItem
